import moment from 'moment-timezone';

// PROD-7828 D4: when the teacher asked for a team-cancel, relative to session start. Mirrors the apis enum.
export const TEACHER_CANCEL_BUCKET_OPTIONS = [
  { value: 'OUTSIDE_24H', label: 'More than 24h before start' },
  { value: 'WITHIN_24_1H', label: '24h–1h before start' },
  { value: 'WITHIN_1H_OR_AFTER', label: 'Less than 1h before / after start' }
];

// Bucket from (session start − exact request time). Seconds-based >= so exact 24h/1h land in the earlier bucket, like the engine.
export function derive_cancel_bucket(session_start_epoch, requested_at_local, iana_timezone) {
  const requested = moment.tz(requested_at_local, iana_timezone);
  if (!requested_at_local || !requested.isValid()) return '';
  const secs = moment(session_start_epoch).diff(requested, 'seconds');
  if (secs >= 24 * 3600) return 'OUTSIDE_24H';
  if (secs >= 3600) return 'WITHIN_24_1H';
  return 'WITHIN_1H_OR_AFTER';
}
